import React from 'react';
import Cta from '@components/mir-cta/Cta';

const index = ({ cta }) => {
  return (
    <Cta data={cta}/>
  );};

export default index;
